export enum AvtalstypEnum {
  PROCENT_BEGRANSNING = 'PROCENT_BEGRANSNING',
  ENDAST_HEMVISTSTAT = 'ENDAST_HEMVISTSTAT',
  INGEN_BEGRANSNING = 'INGEN_BEGRANSNING',
  INGET_AVTAL = 'INGET_AVTAL'
}
